wbApp.controller('LeadsTabsUserHistoryCoursesCtrl', ['$scope', '$modal', '$translate', 'courseRegistrationSvc', 'gridSortSvc',
function ($scope, $modal, $translate, courseRegistrationSvc, gridSortSvc) {

    var selectedLead = null;
    var isActive = false;
    var loaded = false;

    $scope.$on('leadSelectionChanged', function (e, newlySelectedLead) {
        if (newlySelectedLead) {
            if (isActive) {
                loadData(newlySelectedLead);
            } else {
                loaded = false;
            }
        }
        else {
            $scope.leadNotes = [];
            fullLead = null;
        }

        selectedLead = newlySelectedLead;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedLead) {
                    loadData(selectedLead);
                }
            }
        } else {
            isActive = false;
        }
    });

    function loadData(lead) {
        if (lead.isNotRegisteredUser) {
            $scope.courseRegistrations = [];
            loaded = true;
        }
        else {
            $scope.leadNotes = [];
            courseRegistrationSvc.getAllCoursesByUser(lead.userId).$promise.then(function (data) {
                $scope.courseRegistrations = data;
                loaded = true;
            }, function (error) {
                $scope.courseRegistrations = [];
                loaded = false;
            });
        }
    }

    function getFullName(name, middleName, surName) {
        var fullName = name;
        if (!!middleName) {
            if (!!fullName) {
                fullName = fullName + " " + middleName;
            }
            else {
                fullName = middleName;
            }
        }

        if (!!surName) {
            if (!!fullName)
                fullName = fullName + " " + surName;
            else
                fullName = surName;
        }

        return fullName;
    }

    $scope.courseRegistrationsGridSettings = {
        name: 'courseRegistrations',
        columns: [
            { dataField: 'courseRegistrationID', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            {
                dataField: 'studentSurname',
                caption: $translate.instant('TXT_LBL_STUDENT'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return getFullName(rowData.studentName, rowData.studentMiddleName, rowData.studentSurname);
                },
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName(data, 'studentName', 'studentSurname', 'studentMiddleName') }, 
                width: '140px'
            },
            { dataField: 'semesterName', caption: $translate.instant('TXT_LBL_SEMESTER'), dataType: 'string', width: '140px' },
            { dataField: 'courseFullName', caption: $translate.instant('TXT_LBL_COURSE'), dataType: 'string', width: '300px' },
            {
                dataField: 'firstDate',
                caption: $translate.instant('TXT_MENU_SCHEDULE'),
                dataType: 'date',
                format: { raw: "EEE HH:mm" },
                calculateSortValue: function (rowData) {
                    var mfirstLesson = moment(rowData.firstLesson);
                    return mfirstLesson.isValid()
                        ? mfirstLesson.day() * 10000 + mfirstLesson.hour() * 100 + mfirstLesson.minute()
                        : rowData.firstLesson;
                },
                width: '90px'
            },
            { dataField: 'notes', caption: $translate.instant('TXT_LBL_NOTE'), dataType: 'string' },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'paymentsSum', caption: $translate.instant('TXT_LBL_PAYMENTS'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'registrationDate', caption: $translate.instant('TXT_LBL_REGISTRATION_DATE'), dataType: 'date', format: { type: 'shortDate' }, width: '100px', sortOrder: 'desc' },
        ],
        onRowPrepared: function (e) {
            if (!!selectedLead && selectedLead.conversionType == 1 && !!selectedLead.conversionReferenceId) {
                if (e.rowType == "data") {
                    var data = e.component.getKeyByRowIndex(e.rowIndex);
                    if (data.courseRegistrationID == selectedLead.conversionReferenceId) {
                        e.rowElement.addClass('text-danger');
                    }
                }
            }
        },

    }

}]);
